import React from 'react';
import { Hero } from './components/sections/Hero';
import { ProblemSolution } from './components/sections/ProblemSolution';
import { HowItWorks } from './components/sections/HowItWorks';
import { Testimonials } from './components/sections/Testimonials';
import { ExpertEndorsement } from './components/sections/ExpertEndorsement';
import { OfferBonuses } from './components/sections/OfferBonuses';
import { Guarantee } from './components/sections/Guarantee';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { SalesNotification } from './components/ui/SalesNotification';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#D4AF37] selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSolution data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Testimonials data-id="element-5" />
        <ExpertEndorsement data-id="element-6" />
        <OfferBonuses data-id="element-7" />
        <Guarantee data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <SalesNotification data-id="element-11" />
    </div>;
}